module.exports = __webpack_public_path__ + "img/lessontake_resources_return.da7d664b.svg";